const charcoal = '#3d3d3d';
const mid = '#5a5a5a';
const lime = '#a8d23a';
const light = '#e8e8e8';

export function GardenIcon() {
  return (
    <svg viewBox="0 0 140 110" fill="none" aria-hidden="true">
      <ellipse cx="70" cy="100" rx="48" ry="5" fill={light} />
      <path d="M28 78c0-8 6-12 14-12h8l4-16h18l6 16h10c8 0 12 5 12 12v8H28v-8z" fill={charcoal} />
      <path d="M36 66c1-8 6-14 14-15" stroke={lime} strokeWidth="2.5" strokeLinecap="round" />
      <path d="M78 51c6 1 10 7 12 15" stroke={lime} strokeWidth="2.5" strokeLinecap="round" />
      <rect x="96" y="48" width="8" height="36" rx="2" fill={mid} />
      <path d="M90 48h20l-2 8H92l-2-8z" fill={lime} />
      <path d="M22 42c8 2 14 10 16 20" stroke={lime} strokeWidth="3" strokeLinecap="round" />
      <circle cx="22" cy="40" r="5" fill={mid} />
      <path d="M108 70c10-2 16-10 18-20" stroke={lime} strokeWidth="3.5" strokeLinecap="round" />
      <ellipse cx="118" cy="88" rx="10" ry="6" fill={charcoal} />
      <rect x="52" y="70" width="14" height="10" rx="2" fill={lime} opacity="0.7" />
    </svg>
  );
}

export function FurnitureIcon() {
  return (
    <svg viewBox="0 0 140 110" fill="none" aria-hidden="true">
      <ellipse cx="70" cy="100" rx="50" ry="5" fill={light} />
      <rect x="18" y="42" width="36" height="48" rx="3" fill={charcoal} />
      <rect x="22" y="48" width="28" height="8" rx="1.5" fill={lime} />
      <rect x="22" y="60" width="28" height="8" rx="1.5" fill={lime} />
      <rect x="22" y="72" width="28" height="8" rx="1.5" fill={lime} />
      <rect x="62" y="28" width="40" height="62" rx="3" fill={charcoal} />
      <path d="M82 28v62" stroke="#2a2a2a" strokeWidth="2" />
      <circle cx="78" cy="58" r="2" fill={lime} />
      <circle cx="86" cy="58" r="2" fill={lime} />
      <rect x="108" y="58" width="18" height="32" rx="2" fill={mid} />
      <rect x="112" y="52" width="10" height="8" fill={lime} />
    </svg>
  );
}

export function SofaIcon() {
  return (
    <svg viewBox="0 0 140 110" fill="none" aria-hidden="true">
      <ellipse cx="70" cy="100" rx="50" ry="5" fill={light} />
      <rect x="14" y="52" width="72" height="32" rx="8" fill={charcoal} />
      <rect x="20" y="42" width="60" height="16" rx="6" fill={mid} />
      <rect x="28" y="56" width="18" height="14" rx="3" fill={lime} />
      <rect x="52" y="56" width="18" height="14" rx="3" fill={lime} />
      <rect x="18" y="82" width="8" height="10" rx="2" fill={charcoal} />
      <rect x="74" y="82" width="8" height="10" rx="2" fill={charcoal} />
      <rect x="96" y="48" width="32" height="36" rx="8" fill={charcoal} />
      <rect x="102" y="40" width="20" height="14" rx="5" fill={mid} />
      <rect x="106" y="56" width="14" height="12" rx="3" fill={lime} />
      <rect x="100" y="82" width="7" height="10" rx="2" fill={charcoal} />
      <rect x="118" y="82" width="7" height="10" rx="2" fill={charcoal} />
    </svg>
  );
}

export function ShedIcon() {
  return (
    <svg viewBox="0 0 140 110" fill="none" aria-hidden="true">
      <ellipse cx="70" cy="100" rx="48" ry="5" fill={light} />
      <path d="M30 48l40-22 40 22v42H30V48z" fill={charcoal} />
      <path d="M30 48l40-22 40 22" stroke={mid} strokeWidth="2" />
      <rect x="52" y="58" width="22" height="32" rx="2" fill="#2f2f2f" />
      <rect x="18" y="72" width="16" height="18" rx="2" fill="#c4a574" />
      <rect x="98" y="68" width="18" height="22" rx="2" fill="#c4a574" />
      <rect x="108" y="78" width="14" height="12" rx="2" fill={lime} />
      <circle cx="70" cy="74" r="2" fill={lime} />
    </svg>
  );
}

export function HouseIcon() {
  return (
    <svg viewBox="0 0 140 110" fill="none" aria-hidden="true">
      <ellipse cx="70" cy="100" rx="50" ry="5" fill={light} />
      <rect x="18" y="52" width="34" height="34" rx="6" fill={charcoal} />
      <rect x="24" y="44" width="22" height="12" rx="4" fill={mid} />
      <rect x="28" y="58" width="12" height="10" rx="2" fill={lime} />
      <rect x="62" y="38" width="6" height="48" fill={mid} />
      <circle cx="65" cy="34" r="8" fill={lime} opacity="0.85" />
      <rect x="78" y="48" width="28" height="20" rx="2" fill={charcoal} />
      <rect x="82" y="52" width="20" height="12" fill="#222" />
      <rect x="112" y="62" width="16" height="24" rx="2" fill="#c4a574" />
      <rect x="98" y="78" width="14" height="8" rx="1" fill={lime} />
    </svg>
  );
}

export function ApplianceIcon() {
  return (
    <svg viewBox="0 0 140 110" fill="none" aria-hidden="true">
      <ellipse cx="70" cy="100" rx="50" ry="5" fill={light} />
      <rect x="14" y="48" width="32" height="42" rx="3" fill={charcoal} />
      <rect x="18" y="52" width="24" height="10" fill={mid} />
      <circle cx="22" cy="57" r="1.5" fill={lime} />
      <circle cx="28" cy="57" r="1.5" fill={lime} />
      <rect x="52" y="28" width="30" height="62" rx="3" fill={charcoal} />
      <path d="M52 48h30" stroke="#2a2a2a" strokeWidth="2" />
      <circle cx="74" cy="40" r="2" fill={lime} />
      <rect x="94" y="42" width="32" height="48" rx="3" fill={charcoal} />
      <circle cx="110" cy="66" r="12" stroke={mid} strokeWidth="3" />
      <circle cx="110" cy="66" r="6" fill={lime} opacity="0.5" />
    </svg>
  );
}

export function MattressIcon() {
  return (
    <svg viewBox="0 0 140 110" fill="none" aria-hidden="true">
      <ellipse cx="70" cy="100" rx="46" ry="5" fill={light} />
      <path
        d="M22 72l70-28c4-1.5 8 1 9 5l10 28c1 4-1.5 8-5.5 9L36 108c-4 1.5-8-1-9-5L16 77c-1-4 1.5-8 6-5z"
        fill="#f5f5f5"
        stroke={charcoal}
        strokeWidth="2.5"
      />
      <path d="M28 78l64-26" stroke={lime} strokeWidth="3" strokeLinecap="round" />
      <ellipse cx="88" cy="52" rx="16" ry="10" fill="#f5f5f5" stroke={charcoal} strokeWidth="2" />
      <path d="M76 52c4-4 12-6 20-4" stroke={lime} strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

export function InstallationIcon() {
  return (
    <svg viewBox="0 0 140 110" fill="none" aria-hidden="true">
      <ellipse cx="70" cy="100" rx="50" ry="5" fill={light} />
      <rect x="18" y="78" width="40" height="8" rx="1" fill={mid} />
      <rect x="22" y="70" width="32" height="8" fill="#c4a574" />
      <rect x="26" y="48" width="24" height="22" rx="2" fill="#c4a574" />
      <path d="M26 56h24M26 62h24" stroke="#a08050" strokeWidth="1.5" />
      <rect x="68" y="58" width="28" height="32" rx="2" fill={charcoal} />
      <path d="M72 66h20M72 74h20M72 82h14" stroke={mid} strokeWidth="2" />
      <path d="M104 88l10-18 10 18H104z" fill={mid} />
      <path d="M108 88h16v4H108z" fill={charcoal} />
      <ellipse cx="122" cy="78" rx="10" ry="12" fill={lime} />
      <path d="M122 68c-1 4-1 8 0 12" stroke="#2a2a2a" strokeWidth="1.5" />
    </svg>
  );
}

export function OfficeIcon() {
  return (
    <svg viewBox="0 0 140 110" fill="none" aria-hidden="true">
      <ellipse cx="70" cy="100" rx="50" ry="5" fill={light} />
      <rect x="28" y="58" width="56" height="8" rx="2" fill={charcoal} />
      <rect x="34" y="66" width="6" height="24" fill={mid} />
      <rect x="72" y="66" width="6" height="24" fill={mid} />
      <rect x="48" y="40" width="28" height="18" rx="2" fill={mid} />
      <rect x="88" y="50" width="18" height="28" rx="4" fill={charcoal} />
      <rect x="92" y="44" width="10" height="8" rx="2" fill={mid} />
      <path d="M18 48v20" stroke={charcoal} strokeWidth="3" strokeLinecap="round" />
      <path d="M12 48h14" stroke={charcoal} strokeWidth="3" strokeLinecap="round" />
      <ellipse cx="118" cy="78" rx="12" ry="14" fill={lime} />
      <path d="M112 72c2-4 6-6 10-4M114 80c3-3 8-4 12-2" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
      <rect x="54" y="84" width="12" height="8" rx="1" fill="#ddd" transform="rotate(-12 60 88)" />
    </svg>
  );
}

export function WheelieBinIcon() {
  return (
    <svg viewBox="0 0 140 110" fill="none" aria-hidden="true">
      <ellipse cx="70" cy="100" rx="36" ry="5" fill={light} />
      <path d="M42 38h56l-6 52a8 8 0 0 1-8 7H56a8 8 0 0 1-8-7L42 38z" fill={charcoal} />
      <rect x="38" y="32" width="64" height="10" rx="3" fill={mid} />
      <path d="M58 32V26a12 12 0 0 1 24 0v6" stroke={mid} strokeWidth="4" strokeLinecap="round" />
      <circle cx="70" cy="68" r="14" fill={lime} />
      <path
        d="M70 58v8l5 3M64 72c2 4 6 6 10 4"
        stroke={charcoal}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <circle cx="52" cy="94" r="5" fill="#2a2a2a" />
      <circle cx="88" cy="94" r="5" fill="#2a2a2a" />
    </svg>
  );
}

export function PileOfRubbishIcon() {
  return (
    <svg viewBox="0 0 140 110" fill="none" aria-hidden="true">
      <ellipse cx="70" cy="100" rx="48" ry="5" fill={light} />
      <path d="M34 82c0-10 8-14 18-14h12l6-20h24l8 20h12c10 0 16 6 16 14v8H34v-8z" fill={charcoal} />
      <path d="M44 68c2-12 10-20 22-22" stroke="#2a2a2a" strokeWidth="3" strokeLinecap="round" />
      <path d="M90 46c8 2 14 10 16 22" stroke="#2a2a2a" strokeWidth="3" strokeLinecap="round" />
      <rect x="50" y="38" width="18" height="28" rx="2" fill="#5c4033" transform="rotate(-18 59 52)" />
      <rect x="84" y="34" width="14" height="32" rx="2" fill="#7a5230" transform="rotate(16 91 50)" />
      <path d="M66 52l24-8 4 12-24 8-4-12z" fill="#c4a574" />
      <ellipse cx="108" cy="82" rx="12" ry="10" fill="#3b82f6" />
      <ellipse cx="108" cy="75" rx="9" ry="4" fill="#60a5fa" />
      <rect x="28" y="86" width="18" height="8" rx="2" fill={lime} />
    </svg>
  );
}

export function GymEquipmentIcon() {
  return (
    <svg viewBox="0 0 140 110" fill="none" aria-hidden="true">
      <ellipse cx="70" cy="100" rx="50" ry="5" fill={light} />
      <rect x="18" y="48" width="40" height="8" rx="2" fill={mid} />
      <rect x="18" y="40" width="8" height="40" rx="2" fill={charcoal} />
      <rect x="50" y="56" width="8" height="24" rx="2" fill={charcoal} />
      <path d="M26 48v-10c0-4 4-8 10-8h8" stroke={charcoal} strokeWidth="3" strokeLinecap="round" />
      <rect x="68" y="62" width="36" height="10" rx="3" fill={charcoal} />
      <rect x="74" y="52" width="24" height="12" rx="3" fill={lime} />
      <rect x="78" y="72" width="6" height="16" fill={mid} />
      <rect x="88" y="72" width="6" height="16" fill={mid} />
      <circle cx="120" cy="78" r="8" fill={charcoal} />
      <circle cx="120" cy="78" r="4" fill={mid} />
      <rect x="108" y="76" width="24" height="4" rx="2" fill={mid} />
      <circle cx="108" cy="78" r="6" fill={charcoal} />
    </svg>
  );
}

export function GarageIcon() {
  return (
    <svg viewBox="0 0 140 110" fill="none" aria-hidden="true">
      <ellipse cx="70" cy="100" rx="50" ry="5" fill={light} />
      <circle cx="36" cy="62" r="16" stroke={charcoal} strokeWidth="4" fill="none" />
      <circle cx="36" cy="62" r="3" fill={charcoal} />
      <path d="M36 46v-8M22 70l-8 8M50 70l8 8" stroke={charcoal} strokeWidth="3" strokeLinecap="round" />
      <path d="M52 54h18l4 12H50l2-12z" fill={mid} />
      <circle cx="88" cy="78" r="12" fill={charcoal} />
      <circle cx="88" cy="78" r="7" fill={mid} />
      <circle cx="108" cy="72" r="10" fill={charcoal} />
      <circle cx="108" cy="72" r="5.5" fill={mid} />
      <circle cx="124" cy="66" r="8" fill={charcoal} />
      <circle cx="124" cy="66" r="4" fill={mid} />
      <rect x="58" y="70" width="22" height="16" rx="2" fill={charcoal} />
      <rect x="62" y="66" width="14" height="6" rx="1" fill={lime} />
      <path d="M66 74v8M72 74v8M78 74v8" stroke={lime} strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}
